<!--到店客流里面的 添加到店记录-->
<template>
  <article>
    <group gutter="0px" class="status">
      <cell title="记录类型" value="电话记录"></cell>
      <cell title="通话时长" :value="getCallTime()"></cell>
    </group>
    <group title="购车意向" class="status">
      <selector title="意向级别" :options="intentionLevel" v-model="record.intention_level"></selector>
      <cell title="购车意向" primary="content" class="status-left status-cell">
        <div slot="value" class="status-cell-group">
          <cell @click.native="selModels(true,index,item.car_model_id)"
                v-for="(item,index) in record.intention_cars" :key="index"
                :title="item.car_model_name" class="car-intention"
                is-link>
          </cell>
          <cell v-if="record.intention_cars.length < 3" @click.native="selModels(true)" title="请选择+"
                class="car-intention f-color"
                is-link></cell>
        </div>
      </cell>

    </group>
    <group title="提醒设置">
      <datetime title="预约到店" class="datetime" placeholder="请选择预约到店时间" :start-date="start_date" :end-date="end_date"
                format="YYYY-MM-DD HH:mm" year-row="{value}年" month-row="{value}月" day-row="{value}日"
                hour-row="{value}时" minute-row="{value}分" confirm-text="完成" cancel-text="取消" :min-hour="8"
                :max-hour="19" v-model="record.next_arrive_at"></datetime>
      <datetime title="下次联系" class="datetime" placeholder="请选择下次致电时间"
                format="YYYY-MM-DD" year-row="{value}年" month-row="{value}月" day-row="{value}日" confirm-text="完成"
                cancel-text="取消" v-model="record.next_contact_at" :start-date="start_date"
                :end-date="end_date"></datetime>
    </group>
    <group title="其他备注">
      <x-textarea placeholder="请记录你的跟进情况，不少于3个且不超过60个文字" :show-counter="false" :max="60" class="sale-record-text"
                  ref=autosize                 v-model="record.remark">
      </x-textarea>
    </group>
    <section class="btn-bottom">
      <div class="btn-fix">
        <a class="btn" href="javascript:void(0);" @click.stop="toSave()">确认提交</a>
      </div>
    </section>
  </article>
</template>

<script>
import {
  XTextarea,
  Selector,
  Datetime,
  Cell,
  Group
} from '@lx-frontend/cvux'
import cache from '../../../common/cache'

export default {
  components: {
    XTextarea,
    Selector,
    Datetime,
    Cell,
    Group
  },
  data () {
    return {
      start_date: null,
      end_date: null,
      from: '',
      customer_id: '', // 客户id,
      customer_task_id: null, // 客户任务里面传递
      localDataKey: 'addCustomerRecordLocalData',
      originUrl: 'originUrl',
      car_color: [],
      intentionLevel: [],
      record: {
        intention_level: '2',
        intention_cars: [],
        remark: ''
      }
    }
  },
  created () {
    let params = this.$route.params
    let query = this.$route.query
    this.customer_id = params.id
    this.customer_task_id = query.customer_task_id || null
    this.start_date = this.futureTime(1)
    this.end_date = this.futureTime(180)
    this.from = query.from || ''
    this.$rest.saleManage.getEnums().then(res => {
      if (res.code === 0) {
        this.intentionLevel = res.data.intention_level
        this.car_color = res.data.car_color
        // 是否缓存数据.
        let localData = cache.getSessionData(this.localDataKey)
        if (localData && localData.record) {
          this.record = localData.record
        } else {
          this.getCustomerInfo()
        }
        // 是否编辑页面购车意向
        let modelId = query.modelId
        if (modelId) {
          this.$rest.saleManage.getAppointedCarInfo(null, modelId).then((res) => {
            if (res.code === 0) {
              let outer = query.outer
              let inner = query.inner
              let obj = {
                car_model_id: parseInt(modelId),
                outer_color: parseInt(outer),
                inner_color: parseInt(inner),
                car_model_name: res.data.model_name
              }
              let innerColorCh = this.car_color.find(t => {
                return inner === t.key
              })
              if (innerColorCh) {
                obj.inner_color_ch = innerColorCh.value
              }
              let outerColorCh = this.car_color.find(t => {
                return outer === t.key
              })
              if (outerColorCh) {
                obj.outer_color_ch = innerColorCh.value
              }
              // 更改/替换
              if (localData.chooseItem) {
                let index = localData.chooseItem.index
                Object.assign(this.record.intention_cars[index], obj)
              } else {
                // 添加
                let intentionCarsEX = this.record.intention_cars.findIndex(x => {
                  return x.car_model_id === parseInt(modelId)
                })
                if (intentionCarsEX === -1) {
                  this.record.intention_cars.push(obj)
                }
              }
            }
          })
        }
      }
    })
  },
  methods: {
    getCallTime () {
      let callDuration = this.$route.query.call_duration
      if (!callDuration || callDuration <= 0) return 0
      let t = callDuration / 1000
      let h = Math.floor(t / 3600)
      let m = Math.floor((t / 60 % 60))
      let s = Math.floor((t % 60))
      if (h < 1) {
        return m + '\'' + s + '\''
      } else {
        return h + '\'' + m + '\'' + s + '\''
      }
    },
    futureTime (days) {
      let millSeconds = Math.abs(new Date().getTime() + (days * 24 * 60 * 60 * 1000))
      let future = new Date(millSeconds)
      let year = future.getFullYear()
      let month = future.getMonth() + 1
      if (month < 10) month = '0' + month
      let date = future.getDate()
      if (date < 10) date = '0' + date
      return (year + '-' + month + '-' + date)
    },
    getCustomerInfo () {
      this.$rest.saleManage.arrivedCustomerInfo(null, this.customer_id).then(res => {
        if (res.code === 0) {
          this.record = res.data
          if (this.record.intention_cars.length) {
            this.record.intention_cars = this.record.intention_cars.map(v => {
              let innerColorCh = this.car_color.find(t => {
                return v.inner_color === parseInt(t.key)
              })
              if (innerColorCh) {
                v.inner_color_ch = innerColorCh.value
              }
              let outerColorCh = this.car_color.find(t => {
                return v.outer_color === parseInt(t.key)
              })
              if (outerColorCh) {
                v.outer_color_ch = outerColorCh.value
              }
              return v
            })
          }
          this.record.intention_level = this.record.intention_level + ''
          this.record.next_arrive_at = this.record.next_arrive_at || ''
          this.record.next_contact_at = this.record.next_contact_at || ''
        }
      })
    },
    selModels (flag, index, editId) {
      // 当前路径
      cache.setSessionData(this.originUrl, {
        from: 'addCustomerRecord',
        path: '/salemanage/staff/addcustomerrecord/' + this.customer_id,
        includeColor: flag
      })
      // 当前页面数据
      let chooseItem = null
      if (typeof index !== 'undefined' && typeof editId !== 'undefined') {
        chooseItem = { index: index, editId: editId }
      }
      cache.setSessionData(this.localDataKey, { record: this.record, chooseItem: chooseItem })
      this.$router.push('/salemanage/car/intendbrands')
    },
    toSave () {
      let record = this.record
      let remark = record.remark
      if (!remark || remark.length < 3 || remark.length > 60) {
        this.showToast('备注信息必须为3~60个文字之间')
        return false
      }
      let transport = {
        'customer_id': parseInt(this.customer_id),
        'customer_task_id': parseInt(this.customer_task_id),
        'intention_cars': record.intention_cars || [],
        'intention_level': record.intention_level ? +record.intention_level : 2,
        'next_contact_at': record.next_contact_at || null,
        'remark': record.remark
      }
      let callDuration = this.$route.query.call_duration
      if (callDuration) {
        transport.call_duration = Math.round(callDuration / 1000)
      } else {
        transport.call_duration = 0
      }
      if (record.next_arrive_at === '' || record.next_arrive_at === null) {
        transport.next_arrive_at = null
      } else if (record.next_arrive_at) {
        let date = new Date(record.next_arrive_at)
        if (date.getSeconds() > 0 || record.next_arrive_at.endsWith('00')) {
          transport.next_arrive_at = record.next_arrive_at
        } else {
          transport.next_arrive_at = record.next_arrive_at + ':00'
        }
      }
      this.$rest.saleManage.createCustomerPhoneNote(transport).then(res => {
        if (res.code === 0) {
          cache.clearSessionData('customerArchivesLocalData')
          this.showToast('提交成功')
          if (this.from === 'detail') {
            this.$router.push({ path: '/salemanage/staff/customerarchives', query: { id: this.customer_id } })
          }
        } else {
          this.showToast(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
